import React from 'react';
import styled from 'styled-components';

import type { IDatePickerTab } from './types';

export const DatePickerTab = (props: IDatePickerTab): JSX.Element => {
  const { text, icon: Icon, isSelected, handleClick } = props;

  return (
    <li>
      <StyledButton type="button" $isSelected={isSelected} onClick={handleClick}>
        <Icon $isSelected={isSelected} />
        <StyledButtonText>{text}</StyledButtonText>
      </StyledButton>
    </li>
  );
};

const StyledButton = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;

  padding: 12px 16px;
  cursor: pointer;

  border: none;
  border-radius: 40px;

  ${({ $isSelected }) => `
    background: ${$isSelected ? '#f8e71c;' : 'none'};
    color: ${$isSelected ? '#17181a' : '#4d4d4d'};
  `};
`;

const StyledButtonText = styled.span`
  margin-left: 8px;
`;
